import { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from 'reactstrap';

/**
 * Modal component for confirming Statement of Account (SOA) deletion
 * @param {Object} props - Component props
 * @param {boolean} props.open - Controls modal visibility
 * @param {Function} props.onClose - Callback to close the modal
 * @param {Function} props.onDelete - Callback to handle SOA deletion
 * @param {Object} props.soa - SOA object to be deleted
 * @returns {JSX.Element} Modal for confirming SOA deletion
 */
const DeleteSOAConfirmationModal = ({
    open,
    onClose,
    onDelete,
    soa,
}) => {
    const [loading, setLoading] = useState(false);

    /**
     * Handles the confirmation of SOA deletion
     * @returns {Promise<void>} Executes deletion and closes modal
     */
    const handleConfirm = async () => {
        try {
            setLoading(true);
            if (onDelete) {
                await onDelete();
            }
            onClose();
        } catch (error) {
            console.error('Delete failed:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={open} toggle={onClose} className="soa-dialog">
            <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>
            <ModalBody>
                <p className="mb-0">
                    Are you sure you want to delete the Statement of Account "
                    {soa?.id || soa?._id || 'this SOA'}"? This action cannot be undone.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button
                    outline
                    className="soa-button"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button
                    color="danger"
                    className="soa-button"
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading && <Spinner size="sm" className="me-2" />}
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export { DeleteSOAConfirmationModal };